export default __webpack_public_path__ + "static/media/banner-covid19.60f33d73.png";